import { useMediaQuery, useTheme } from '@mui/material';
import './Banner.scss';
import banner from '../../../assets/images/gettingstarted/banner.png';
import { useEffect, useRef } from 'react';

const Banner = ({ data, description, isFooterNavigation }) => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('md'));
  const headingRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    // Add a small delay to ensure the component is fully mounted and visible
    const timer = setTimeout(() => {
      if (isFooterNavigation && headingRef.current) {
        headingRef.current.setAttribute('tabindex', '-1'); // Use -1, not 1
        headingRef.current.focus();
      }
    }, 220); // Small delay to ensure DOM is ready

    return () => clearTimeout(timer);
     // eslint-disable-next-line 
  }, []); // Empty dependency array - run only once when component mounts

  return (
    <>
      {' '}
      <section
        className={` getting-started-banner-container ${
          sm && 'mobileGSbanner'
        }`}
        aria-labelledby="gettingStartedTitle"
      >
        <div className="bannerCopy" id="gettingStartedTitle">
          {' '}
          <h1 ref={headingRef}>{data?.title}</h1>
          <p>{data?.paragraph}</p>
        </div>
      </section>
      {/* Below is a crazy hack b/c of way api nav menu works, can't get banner to edge unless absolute, but that causes a bad responsiveness, so duplicating menu and hiding as a sizer for now... FIX when API nav gets reworked to go on top */}
      <section
        className={`hiddenBanner getting-started-banner-container ${
          sm && 'mobileGSbanner'
        }`}
        aria-labelledby="gettingStartedTitle"
      >
        <div className="bannerCopy" id="gettingStartedTitle">
          {' '}
          <h1
          // ref={headingRef}
          >
            {data?.title}
          </h1>
          <p>{description}</p>
        </div>
      </section>
    </>
  );
};

export default Banner;
